export const howItWorksSteps = [
    {
      step: 'Step 1',
      icon: '/img/fnol-step-1.png',
      text: 'Policyholder receives SMS/email link immediately after incident',
    },
    {
      step: 'Step 2',
      icon: '/img/fnol-step-2.png',
      text: 'Guided mobile app captures vehicle photos with real-time quality validation',
    },
    {
      step: 'Step 3',
      icon: '/img/fnol-step-3.png',
      text: 'AI detects damage across 163 parts and extracts VIN/odometer automatically',
    },
    {
      step: 'Step 4',
      icon: '/img/fnol-step-4.png',
      text: 'System estimates repair value and compares it to the vehicle value for total loss vs repairable loss analysis',
    },
    {
      step: 'Step 5',
      icon: '/img/fnol-step-5.png',
      text: 'Total loss vs repairable loss decision taken based on the damage report',
    },
  ]
  
  export const keyBenefits = [
    {
      icon: '/img/fnol-benefit-1.png',
      title: 'Instant first notice of loss acknowledgement.',
      link: '#',
      text: 'No phone queues'
    },
    {
      icon: '/img/fnol-benefit-2.png',
      title: 'Touchless claims processing eliminates adjuster site visits.',
      link: '#',
      text: 'For straightforward cases'
    },
    {
      icon: '/img/fnol-benefit-3.png',
      title: 'Insurance claim automation reduces handling time from days to minutes',
      link: '#',
    },
    {
      icon: '/img/fnol-benefit-4.png',
      title: '90% cost reduction in FNOL intake and initial assessment operations',
      link: '#',
    },
  ]
  
  export const automationFeatures = [
    {
      icon: '/img/fnol intake.png',
      title: 'Instant Intake',
      text: 'First notice of loss submission and data capture mobile Interface.',
    },
    {
      icon: '/img/fnol ai.png',
      title: 'AI Assessment',
      text: 'Damage detection, severity classification and repair estimation in seconds.',
    },
    {
      icon: '/img/fnol fraud.png',
      title: 'Fraud Screening',
      text: 'Automatic identification of common signs of fraud during insurance, affiliate claims.',
    },
    {
      icon: '/img/fnol routing.png',
      title: 'Smart Routing',
      text: 'Intelligent claims triage that routes each claim to the right team based on adjuster.',
    },
  ]
  export const stats = [
    { value: '98%', label: 'Cost Reduction', description: 'Eliminate FNOL intake, adjuster dispatches, phone support for routine claims' },
    { value: '70%', label: 'Faster Processing', description: 'First Notice of Loss to Claim decision takes minutes instead of days' },
    { value: '60-70%', label: 'Touchless Claims', description: 'Majority of claims approved without human intervention' },
    { value: '30-40%', label: 'Fraud Reduction', description: 'AI catches fraudulent claims before payout' },
    { value: '60%', label: 'Increased Customer Satisfaction', description: 'Instant acknowledgment and transparency' },
  ]
  
